import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { type ReactNode, useMemo } from 'react';

import { themeStore } from 'containers/Layout/themeStore';
import { createMainTheme } from './muiTheme';

export function MuiThemeProvider({ children }: { children: ReactNode }) {
  const mode = themeStore.use.theme();
  const mainTheme = useMemo(() => createMainTheme(mode), [mode]);

  return (
    <ThemeProvider theme={mainTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
